import request from '../../../util/SuperagentUtils';
import type {CheckInPayload} from '../../../hooks/checkin/useCheckInSubmit/interfaces';

const ASSET_TYPES_URL = "/api/types/assets";
const BOOKING_URL = "/api/booking"

/**
 * Requests the custom check-in field configuration for an account.
 * Returns `undefined` (no request is made) when `accountId` is empty.
 */
export const requestCheckInFieldsForAccountId = (accountId: string | undefined) => {

    if(accountId) {
        return request.get(`/api/account/${accountId}/check-in-fields`);
    }
}

export const requestAssetTypes = () => {
    return request.get(ASSET_TYPES_URL);
}

export const requestBooking = (bookingId: string) => {
    return request.get(`${BOOKING_URL}/${bookingId}`);
}

// Note: the legacy CheckInLegacy.jsx view also calls this with its own (unchecked) payload shape.
export const checkin = (data: CheckInPayload) => {
    return request.post(`/api/check-in-images`).send(data);
}
